import React, { FC, useEffect, useState } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { set } from 'cypress/types/lodash';
import { Button } from '../button/Button';

// Interface

export interface ButtonBarProps {
  centered?: boolean;
  buttonOne?: ButtonProps;
  buttonTwo?: ButtonProps;
  buttonThree?: ButtonProps;
}

export interface ButtonProps {
  url?: string;
  label?: string;
  onClick?: any;
  target?: string;
}

export interface StyledButtonBarProps {
  centered?: boolean;
}

// Styles

const StyledButtonBar = styled.div<StyledButtonBarProps>`
  ${({ theme: { space, maxMedia, media }, centered }) => css`
    display: flex;
    gap: ${space.xSmall};
    justify-content: center;

    @media (max-width: ${maxMedia.medium}) {
      flex-direction: row;
      flex-direction: column;

      > * {
        width: 100%;
      }
    }

    @media (min-width: ${media.medium}) {
      flex-direction: row;

      ${centered &&
      css`
        justify-content: center;
      `};
    }
  `};
`;

// JSX

export const ButtonBar: FC<ButtonBarProps> = ({
  buttonOne,
  buttonTwo,
  buttonThree,
  centered,
}) => {
  const [firstButton, setFirstButton] = useState<ButtonProps>(buttonOne || {});

  // Some very specific logic the client reqyested to capture channel utm params and apply to a button CTA
  useEffect(() => {
    // Get the current URL search parameters
    const searchParams = new URLSearchParams(window.location.search);

    // Get the value of the 'channel' parameter
    const channelParam = searchParams.get('channel');

    const isQuoteButton =
      buttonOne?.url ===
      'https://quotes.tradedirectinsurance.co.uk/frm_1_PL_BasicInfo.aspx';

    const currentPage =
      typeof window !== 'undefined' ? window.location.pathname : '';


    const isPartnersTerms = currentPage.includes('partners-save-when-you-join');

    if (isQuoteButton && isPartnersTerms) {
      setFirstButton({
        ...buttonOne,
        url: `${buttonOne?.url}?channel=${channelParam}`,
      });
    }
  }, []);

  return (
    <StyledButtonBar centered={centered}>
      {firstButton && <Button variant="primary" {...firstButton} />}
      {buttonTwo && <Button variant="secondary" {...buttonTwo} />}
      {buttonThree && <Button variant="secondaryOutline" {...buttonThree} />}
    </StyledButtonBar>
  );
};

export default ButtonBar;
